// 질문지 PDF 진행률 집계: 문항당 완료 신호 1회만 센다. 실패 문항도 완료로 세되 failed 에 따로 남긴다.
// node:test 단위 테스트 + webpack 빌드 양쪽에서 쓰기 위해 CommonJS 로 작성한다.
function recordLoad(loaded, failed, question_code, is_failed) {
    if (loaded.includes(question_code)) return false
    loaded.push(question_code)
    if (is_failed) failed.push(question_code)
    return true
}

module.exports = {recordLoad}
